import { useEffect, useContext, MouseEvent, useState, useMemo, ReactNode, } from 'react';
// 组件
import { ProTabs, } from '../antd';
import UserDropdown from './subpage/userDropdown';
import ContextMenuAlert from './subpage/contextMenuAlert';
import FullPage from './subpage/fullPage';
// 方法
import { useLocation, useNavigate, } from 'react-router-dom';
import { useAliveController } from 'react-activation';
import LayoutContext, { IRouteTabs } from '../PageLayout/context/LayoutContext';
import { routeNameToBasePath, } from '../utils/utils';
// 常量
import { TabItemType } from '../antd/Tabs';
import './index.less';

interface IContextMenuPathItem {
  path?: string;
  visible: boolean;
  left?: number;
  top?: number;
}
interface TabsRouteProps {
  /** 打开超过多少个Tabs后出现tan过多提示 */
  maxCachePage?: number;
  /** 子节点 */
  children?: ReactNode;
}
/** 路由Tabs */
const TabsRoute: React.FC<TabsRouteProps> = props => {
  const { children, maxCachePage = 10, } = props;
  const [refreshPage, setRefreshPage] = useState<boolean>(false);
  const [contextMenuPath, setContextMenuPath] = useState<IContextMenuPathItem>({
    path: '/',
    visible: false,
    left: 0,
    top: 0,
  });
  const { dropScope, getCachingNodes } = useAliveController();
  const { routeTabs, routes, dispatch } = useContext(
    LayoutContext,
  );
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const currentPathname = routeLocation.pathname;
  const _window = window.__POWERED_BY_WUJIE__ ? window.parent : window;
  useEffect(() => {
    if (currentPathname) {
      if (Array.isArray(routes) && routes.length) {
        const findRoute = routes.find((v: any) => v.path === currentPathname);
        const findRouteTab = routeTabs.find(
          (v: IRouteTabs) => v.path === currentPathname,
        );
        if (findRoute && !findRouteTab) {
          dispatch('addRouteTab', {
            name: findRoute.name,
            path: findRoute.path,
            query: routeLocation.search,
          });
        }
      }
    }
  }, [currentPathname, routes]);
  useEffect(() => {
    setTimeout(() => {
      const childrenKeepNodes = getCachingNodes();
      childrenKeepNodes.forEach(item => {
        const includeTabs = routeTabs.find(v => v.path === item.name);
        if (!includeTabs) {
          setTimeout(() => {
            dropScope(item.id);
          });
        }
      });
    }, 200);
  }, [routeTabs]);
  // 点击Tabs
  const handleTabClick = (key: string) => {
    const findItem = routeTabs.find(v => v.path === key);
    navigate(`${key}${findItem?.query || ''}`);
  };
  // 关闭当前窗口
  const handleEdit = (targetKey: any) => {
    dispatch('deleteRouteTab', { type: 'current', key: targetKey });
  };
  // 鼠标右键
  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    const mouseDom = event.target as HTMLDivElement;
    const currentPath = mouseDom.getAttribute('data-path') as string;
    setContextMenuPath({
      path: currentPath,
      visible: true,
      left: event.pageX - 40,
      top: event.pageY,
    });
  };
  // 取消
  const handleCancel = () => {
    setContextMenuPath({
      visible: false,
      left: 0,
      top: 0,
    });
  };
  // 刷新
  const handleRefresh = () => {
    setRefreshPage(true);
    setTimeout(() => {
      setRefreshPage(false);
    }, 200);
  };
  const tabItems: TabItemType[] = useMemo(() => {
    const newTabItems: TabItemType[] = [];
    const productPathname = routeNameToBasePath(currentPathname);
    routeTabs?.forEach(item => {
      newTabItems.push({
        key: item.path,
        label: (
          <div
            className="tl-tabs-tab"
            data-path={item.path}
            onContextMenu={handleContextMenu}
          >
            {item.name}
          </div>
        ),
        closable: item.path === currentPathname && item.path !== '/' && item.path !== `/${productPathname}` && item.path !== `/${productPathname}/`,
      });
    });
    return newTabItems;
  }, [routeTabs, currentPathname]);

  return (
    <div className="tl-page">
      <div className="tl-page-head">
        <ProTabs
          hideAdd
          activeKey={currentPathname}
          onTabClick={handleTabClick}
          type="editable-card"
          onEdit={handleEdit}
          items={tabItems}
          tabBarExtraContent={
            <div className="tl-page-head-operation">
              <UserDropdown />
              {/* <FullPage /> */}
            </div>
          }
        />
        <ContextMenuAlert
          onCancel={handleCancel}
          onRefresh={handleRefresh}
          onClose={handleEdit}
          {...contextMenuPath}
        />
      </div>
      <div
        className="tl-page-content"
      >
        {!refreshPage && children}
      </div>
    </div>
  );
};

export default TabsRoute;
